module.exports = __webpack_public_path__ + "static/logo-c734d161854d080ab82080d82db36953.png";